import React, { useState } from 'react';
import { Checkbox, Spin } from "antd";
import "./ingredientSelector.css";

const proteins_lowercase =
["chicken", "turkey", "beef", "lamb", "pork", "venison", "bison", "buffalo", 
  "goat", "rabbit", "duck", "goose", "kangaroo", "salmon", "sardines", "mackerel", 
  "herring", "cod", "tilapia", "whitefish", "trout", "chicken_eggs", "duck_eggs", "quail_eggs",
  "liver", "heart", "kidney", "gizzard", "tripe", "bone_broth", "beef_broth", "chicken_broth", "lentils", "chickpeas", 
  "peas", "edamame", "quinoa", "oats", "greek_yogurt", "cottage_cheese" 
];

const veggies_lowercase =
["carrots", "green_beans", "broccoli", "cauliflower", "spinach", "kale", "pumpkin", 
  "butternut_squash", "zucchini", "cucumber", "sweet_potato", "potato_cooked_plain", 
  "peas", "brussels_sprouts", "celery", "beets", "parsnips", "turnips", "lettuce", 
  "cabbage", "bok_choy", "bell_peppers", "asparagus", "okra", "nori_seaweed_plain", 
  "edamame", "chard", "collard_greens"
];

// TODO make sure to put a message that says no seeds or pits 
const fruits_lowercase =
["apple", "bananas", "blueberries", "strawberries", "raspberries", "blackberries", "watermelon", 
  "cantaloupe", "honeydew", "pineapple", "mango", "pear", "peaches", "plum", "kiwi", 
  "cranberries", "coconut", "papaya", "pumpkin", 
  "date", "figs", "goji_berries"
];


interface IngredientSelectorProps {
  selectedIngredients: string[];
  onCheckboxChange: (ingredient: string, checked: boolean) => void;
  isLoading: boolean;
}

const capitalize = (s: string) =>
  s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

const CollapsibleCategory: React.FC<{
  title: string;
  ingredients: string[];
  selectedIngredients: string[];
  onCheckboxChange: (ingredient: string, checked: boolean) => void;
  isLoading: boolean;
}> = ({ title, ingredients, selectedIngredients, onCheckboxChange, isLoading }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="ingredient-category">
      <h3 className="category-title" onClick={() => setIsOpen(!isOpen)}>
        {title} <span>{isOpen ? '▲' : '▼'}</span>
      </h3>
      {isOpen && (
        <div className="category-items">
          {ingredients.map((ingredient) => (
            <label className="checkbox-label" key={ingredient}>
              <Checkbox
                checked={selectedIngredients.includes(ingredient)}
                onChange={(e) => onCheckboxChange(ingredient, e.target.checked)}
                disabled={isLoading}
              >
                {capitalize(ingredient)}
              </Checkbox>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

const IngredientSelector: React.FC<IngredientSelectorProps> = ({
  selectedIngredients,
  onCheckboxChange,
  isLoading,
}) => {
  return (
    <div className="ingredient-selector">
      {isLoading && <Spin size="small" className="loading-spinner" />}

      <div className="ingredient-categories">
        <CollapsibleCategory
          title="Proteins"
          ingredients={proteins_lowercase}
          selectedIngredients={selectedIngredients}
          onCheckboxChange={onCheckboxChange}
          isLoading={isLoading}
        />
        <CollapsibleCategory
          title="Veggies"
          ingredients={veggies_lowercase}
          selectedIngredients={selectedIngredients}
          onCheckboxChange={onCheckboxChange}
          isLoading={isLoading}
        />
        <CollapsibleCategory
          title="Fruitssss"
          ingredients={fruits_lowercase}
          selectedIngredients={selectedIngredients}
          onCheckboxChange={onCheckboxChange}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default IngredientSelector;